import api from "./api";
import endpoints from "./endpoints";

export default {
  load() {
    return api.get(endpoints.user.settings.get).then((x) => Promise.resolve(x.data));
  },
  save(args) {
    return api.post(endpoints.user.settings.post, args);
  }
};
